<template>
  <div class="admin-panel-page">
    <h4 class="title mb-4">Admin Panel</h4>
    <v-card :elevation="1">
      <v-tabs background-color="primary" dark>
        <v-tab v-for="(item, index) in adminPanelTabItems"
          :key="index"
          :to="item.to">{{ item.text }}</v-tab>
      </v-tabs>
      <v-card flat min-height="60vh">
        <v-card-text class="px-6 py-6">
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'admin-panel-page',
  data: () => ({}),
  computed: {
    ...mapGetters('routes', ['adminPanelTabItems']),
  },
};
</script>
